module.exports = __webpack_public_path__ + "img/level-icons-jh.a3db522a.png";